import { EquipmentType, type ProjectPlanQuery } from 'graphql/generated/graphql';

export type TPlanningCategory = ProjectPlanQuery['projectPlan']['planningCategories'][number];

export type TPlanningItem = TPlanningCategory['subitems'][number];

/** A price (number inputs) or an equipment type (selects); null or undefined when cleared. */
export type TPlanFormValue = number | string | null | undefined;

/** Keyed by the category and plan item names. */
export type TPlanFormValues = Record<string, TPlanFormValue>;

const equipmentTypes: readonly string[] = Object.values(EquipmentType);

const isEquipmentType = (value: TPlanFormValue): value is EquipmentType =>
  typeof value === 'string' && equipmentTypes.includes(value);

/**
 * The value of a price field. The field is only shown while its value is a price (the initial user
 * price or the calculated price the toggle sets), so the string branch is not reached.
 */
export const toPrice = (value: TPlanFormValue) => {
  if (typeof value === 'string') return undefined;
  return value;
};

/**
 * The value of an equipment type select. The select is only shown while its value is an equipment
 * type (the initial one or the one the toggle sets), so the last branch is not reached.
 */
export const toEquipmentType = (value: TPlanFormValue) => {
  if (value === null || value === undefined || isEquipmentType(value)) return value;
  return undefined;
};

/**
 * The plan forms have no submit handler: a submit (Enter in an input) made formik call `undefined`
 * and warn "An unhandled error was caught from submitForm()" with this TypeError.
 */
export const missingSubmitHandler = () => {
  throw new TypeError('onSubmit is not a function');
};
